import { Clasificacion } from './../../../models/clasificacion.model';
import { Component, ViewChild, TemplateRef } from "@angular/core";
import { FormControl, FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { MatDialog } from '@angular/material';
declare var jQuery: any;
declare var $: any;
@Component({
    selector: "page-clasificacion",
    templateUrl: "./clasificacion.component.html",
    styleUrls: ['./clasificacion.component.css'],
    providers: [FormService]
})

export class clasificacionComponent {
    @ViewChild('openModal') openModal: TemplateRef<any>;
    @ViewChild('openModalNODATA') openModalNODATA: TemplateRef<any>;

    public rows = [];
    public actualRow;
    public clasificacion: Clasificacion;
    public form;
    public temp_clasif;
    public matcher = new FormService();

    constructor(private dialog: MatDialog) {

        this.form = new FormGroup({
            clasificacion: new FormControl(''),
            metro: new FormControl('')
        })
        if (!JSON.parse(localStorage.getItem("clasificacion"))) {
            localStorage.setItem("clasificacion", JSON.stringify(this.rows));
        } else {
            this.rows = JSON.parse(localStorage.getItem("clasificacion"));

        }
        this.clasificacion = { clasificacion: "", metro: "" };
        this.temp_clasif = { clasificacion: "", metro: "" };
    }

    add_clasificacion() {


        this.actualRow = localStorage.getItem("clasificacion");
        this.rows = JSON.parse(this.actualRow);

        if (!this.form.value.clasificacion && !this.form.value.metro) {
            console.log("no se ingresaron datos");
            this.dialog.open(this.openModalNODATA);

        } else {
            this.rows = this.rows.concat({
                clasificacion: this.form.value.clasificacion,
                metro: this.form.value.metro

            })
            localStorage.setItem("clasificacion", JSON.stringify(this.rows));
            this.form.reset();
        }



        
    }

    get_clasificacion(id) {
        console.log(id)
        for (let x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.temp_clasif.id = id;
                this.temp_clasif.clasificacion = this.rows[x].clasificacion;
                this.temp_clasif.metro = this.rows[x].metro;

                this.dialog.open(this.openModal);
            }
        }
    }

    cleanData() {
        this.temp_clasif = { clasificacion: "", metro: "" };
    }

    saveclasificacion() {
        var id = this.temp_clasif.id;
        console.log(this.temp_clasif)
        for (let x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("clasificacion", JSON.stringify(this.rows));

                $("#clasif_modal").modal("hide");
                this.actualRow = localStorage.getItem("clasificacion");
                this.rows = JSON.parse(this.actualRow);
                this.rows = this.rows.concat({
                    clasificacion: this.temp_clasif.clasificacion,
                    metro: this.temp_clasif.metro
                })
                localStorage.setItem("clasificacion", JSON.stringify(this.rows));
                this.temp_clasif = { clasificacion: "", metro: "" };
                this.dialog.closeAll();
            }
        }
    }

    delete_clasificacion(id) {
        for (let x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("clasificacion", JSON.stringify(this.rows));
            }
        }
        this.actualRow = localStorage.getItem("clasificacion");
        this.rows = JSON.parse(this.actualRow);
    }

}